import { Component, EventEmitter, Input, OnInit, Output, AfterViewInit } from '@angular/core';
import { AppSettingsQuery } from 'chronos-shared';
import { LabelType } from 'chronos-core-client';
import { OuterInfo } from '@app/shared/models';
@Component({
  selector: 'app-print-label-header',
  templateUrl: './print-label-header.component.html',
  styleUrls: ['./print-label-header.component.scss']
})
export class PrintLabelHeaderComponent implements OnInit, AfterViewInit {
  @Input() public printerName: string;
  @Input() public printedLabels: number;
  @Input() public labelsTotal: number;
  @Input() public defaultQuantityPerOuter: number;
  @Input() public quantityPerOuter: number;
  @Input() public collapsible = false;
  @Input() public isCollapsed = true;
  @Input() public labelType: LabelType;
  @Input() public numberOfCopies?: number;
  @Input() public isQuantityPerOuterValid? = false;
  @Input() public isBobbin = false;
  @Input() public producedMaterialId?: number;
  @Input() public slitCount?: number;
  @Input() public isPalletFinished?: boolean;
  @Input() public palletQuantity?: number;
  @Input() public isQuantityPerOuterChangeInProgress = false;
  @Output() public toggleButtonClicked = new EventEmitter<boolean>();
  @Output() public quantityPerOuterChanged = new EventEmitter<OuterInfo>();
  @Output() public numberOfCopiesChanged = new EventEmitter<OuterInfo>();
  @Output() public quantityPerOuterInput = new EventEmitter<OuterInfo>();

  public INPUT_MAX_QUANTITY = 999999;
  public readonly INPUT_MIN_QUANTITY = 1;
  public readonly COPIES_MAX_QUANTITY = 99;
  public readonly COPIES_MIN_QUANTITY = 1;
  public readonly INPUT_STYLE = {
    width: '80px',
    textAlign: 'end'
  };
  public readonly OUTER_LABEL_TYPE = LabelType;
  private oldQuantityPerOuter: number;
  public showInactive = false;

  constructor(private appSettingsQuery: AppSettingsQuery) {}

  public ngOnInit(): void {
    this.showInactive = this.appSettingsQuery.showInactiveElement();
    this.oldQuantityPerOuter = this.quantityPerOuter;
    this.setOuterLabelMaxQuantity();
  }

  public ngAfterViewInit(): void {
    if (this.isBobbin) {
      this.collapsible = true;
      this.isCollapsed = false;
      this.showInactive = false;
    }
  }

  public toggleContent(): void {
    this.isCollapsed = !this.isCollapsed;
    this.toggleButtonClicked.emit(this.isCollapsed);
  }

  public onQuantityPerOuterChange(): void {
    this.isQuantityPerOuterChangeInProgress = true;
    const quantity = this.quantityPerOuter;
    if (this.labelType === LabelType.Outer) {
      this.setQuanityForOuterLabel(quantity);
    } else {
      if (this.oldQuantityPerOuter !== quantity) {
        this.oldQuantityPerOuter = quantity;
        this.quantityPerOuter = quantity;
        this.quantityPerOuterChanged.emit({
          quantityPerOuter: quantity,
          numberCopies: this.numberOfCopies
        });
      }
    }
    this.isQuantityPerOuterChangeInProgress = false;
  }

  public setQuanityForOuterLabel(quantity: number): void {
    this.isQuantityPerOuterChangeInProgress = true;
    if (this.oldQuantityPerOuter !== quantity) {
      this.oldQuantityPerOuter = quantity;
      this.quantityPerOuter = quantity;
      this.quantityPerOuterChanged.emit({
        quantityPerOuter: quantity,
        numberCopies: this.numberOfCopies,
        producedMaterialId: this.producedMaterialId
      });
    }
    this.isQuantityPerOuterChangeInProgress = false;
  }

  public onCopiesPerLabelChanged(): void {
    this.isQuantityPerOuterChangeInProgress = true;
    if (this.numberOfCopies <= 0) {
      this.numberOfCopies = this.INPUT_MIN_QUANTITY;
    }
    this.numberOfCopiesChanged.emit({
      quantityPerOuter: this.quantityPerOuter,
      numberCopies: this.numberOfCopies,
      producedMaterialId: this.producedMaterialId
    });
    this.isQuantityPerOuterChangeInProgress = false;
  }

  public setOuterLabelMaxQuantity(): void {
    if (this.isBobbin) this.INPUT_MAX_QUANTITY = this.palletQuantity;
  }

  public onQuantityPerOuterInput(value: number): void {
    this.quantityPerOuter = value;
    this.quantityPerOuterInput.emit({
      quantityPerOuter: value,
      numberCopies: this.numberOfCopies
    });
  }
}
